// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2HPvs","rightAdornment":"Header_rightAdornment__E3vcR"};